import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type AlertVariant = 'error' | 'warning' | 'info' | 'success';
export type AlertRole = 'alert' | 'status' | 'note';

export interface AlertProps {
    /** Severity of the message. Selects the colours. */
    variant: AlertVariant;
    children: ReactNode;
    /** `alert` interrupts, `status` is announced politely, `note` is not announced. */
    role?: AlertRole;
    /** Spacing or text-size utilities for the outer box. */
    className?: string;
    /** Id of the element that names the box. */
    ariaLabelledBy?: string;
}

const BASE_CLASSES = 'flex items-center gap-4 rounded-lg border px-4 py-3 text-sm';

const VARIANT_CLASSES: Record<AlertVariant, string> = {
    error: 'border-mp-error/20 bg-mp-error-content text-mp-error',
    warning: 'border-mp-warning/20 bg-mp-warning-content text-mp-warning',
    info: 'border-mp-info/20 bg-mp-info-content text-mp-info',
    success: 'border-mp-success/20 bg-mp-success-content text-mp-success',
};

export function Alert({ variant, children, role = 'alert', className, ariaLabelledBy }: AlertProps) {
    return (
        <div role={role} aria-labelledby={ariaLabelledBy} className={twMerge(BASE_CLASSES, VARIANT_CLASSES[variant], className)}>
            {children}
        </div>
    );
}
